import { render } from "./SwdRemoteSearch.vue?vue&type=template&id=f9057a54"
import script from "./SwdRemoteSearch.vue?vue&type=script&lang=js"
export * from "./SwdRemoteSearch.vue?vue&type=script&lang=js"

import "./SwdRemoteSearch.vue?vue&type=style&index=0&id=f9057a54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__